import { Log } from '@/parsing/Log';
import { LogEntryType } from '@/parsing/LogEntry';

import { TimelineMarker, TimelineRow, TimelineRowGroup } from '../../TimelineData';
import { obtainFreeRowForMarker } from '../obtainFreeRowForMarker';
import { TimelineGeneratorContext } from '../TimelineGeneratorContext';

export function generateIosAppEventsGroupFromLog(
  log: Log,
  ctx: TimelineGeneratorContext,
): TimelineRowGroup {
  const rows: TimelineRow[] = [];

  for (const entry of log.entries) {
    if (entry.entryType !== LogEntryType.Generic) {
      continue;
    }
    if (entry.extra.generic?.module !== 'APPLICATIONEVENT') {
      continue;
    }
    if (entry.content.includes('UIKitApplicationEventsLogger is set up')) {
      continue;
    }

    try {
      const info = JSON.parse(entry.content);
      const id: string | undefined = info.identifier;
      if (!id) {
        continue;
      }

      const tooltipContent = entry.content;
      let textOnMarker = '';
      let fillColor = '';
      let textOnMarkerColor = '';

      if (id === 'vcDidAppear') {
        textOnMarker = `${info.viewInfo.typeName} (appear)`;
        fillColor = '#befbae';
        textOnMarkerColor = '#5b7855';
      } else if (id === 'vcDidDisappear') {
        textOnMarker = `${info.viewInfo.typeName} (disappear)`;
        fillColor = '#f7d0ad';
        textOnMarkerColor = '#726154';
      } else if (id === 'pushViewController:animated:') {
        textOnMarker = `${info.otherRelevantViewInfoList[0].typeName} (push)`;
        fillColor = '#b2e9f8';
        textOnMarkerColor = '#4f7476';
      } else if (id === 'becomeFirstResponder') {
        textOnMarker = `${info.viewInfo.typeName} (focus)`;
        fillColor = '#66fcb0';
        textOnMarkerColor = '#10745d';
      } else if (id === 'resignFirstResponder') {
        textOnMarker = `${info.viewInfo.typeName} (unfocus)`;
        fillColor = '#f699c2';
        textOnMarkerColor = '#712561';
      } else {
        continue;
      }

      textOnMarker = textOnMarker.replace('ViewController', 'VC');
      textOnMarker = textOnMarker.replace('Controller', 'Ctrl');

      const marker: TimelineMarker = {
        markerId: ctx.nextMarkerId,
        logEntry: entry,
        startTimeMs: entry.date.getTime(),
        endTimeMs: undefined,
        fillColor,
        textOnMarker,
        textOnMarkerColor,
        tooltipContent,
      };
      ctx.nextMarkerId += 1;

      const row = obtainFreeRowForMarker(rows, marker);
      row.markers.push(marker);
    } catch (error) {
      console.error('Cannot parse JSON for APPLICATIONEVENT for app event', entry.content, error);
      continue;
    }
  }

  const rowGroup: TimelineRowGroup = {
    name: 'Application events',
    rows,
    expanded: true,
  };
  return rowGroup;
}
